import { ArrowRightIcon } from 'features/CaseStudy/assets/icons';

import { Fragment } from 'react';
import styles from './ProductCards.module.css';
import { ProductCard } from './ProductCard/ProductCard';

type ProductCardsProps = {
  products: {
    title: string;
    subtitle: string;
    description: string;
    mediaSrc: string;
  }[];
};

export const ProductCards = ({ products }: ProductCardsProps) => {
  return (
    <div className={styles.productCardsLayout}>
      {products.map((product, index) => {
        const isLastStep = index === products.length - 1;
        return (
          <Fragment key={index}>
            <ProductCard
              title={product.title}
              subtitle={product.subtitle}
              description={product.description}
              mediaSrc={product.mediaSrc}
            />
            {isLastStep ? null : (
              <div className={styles.productCardsStepArrow}>
                <ArrowRightIcon />
              </div>
            )}
          </Fragment>
        );
      })}
    </div>
  );
};
